<div *ngIf="!showDisclaimerBlock">
  <!--If the week number is greater than 0, show the week details-->
  <app-behavior-tracker-details-screen *ngIf="selectedWeekNumber > 0; else summaryView"
    [selectedWeekNumber]="selectedWeekNumber"></app-behavior-tracker-details-screen>

  <!--If the week number is -1, show the weeks summary-->
  <ng-template #summaryView>
    <app-behavior-tracker-summary-screen></app-behavior-tracker-summary-screen>
  </ng-template>
</div>

<div *ngIf="showDisclaimerBlock" class='disclaimer-block-wrapper'>
  <div class="flex flex-row space-x-[1rem]">
    <app-icon svgIcon="exclamation-circle"></app-icon>
    <div class="error-message">
      You or your participants are not part of any group.
    </div>
  </div>
</div>
